module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_kubo-a6102a8dfd2b0bed0eb3d219c72e3325.jpg";